export default "__VITE_ASSET__iDOYmwwh__"